import { render, staticRenderFns } from "./Contact-us.vue?vue&type=template&id=79395e68&scoped=true&"
import script from "./Contact-us.vue?vue&type=script&lang=js&"
export * from "./Contact-us.vue?vue&type=script&lang=js&"
import style0 from "./Contact-us.vue?vue&type=style&index=0&id=79395e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79395e68",
  null
  
)

export default component.exports